<script setup lang="ts">
const cekResiForm = reactive<{
  resi: string[]
}>({
  resi: []
})

const onSubmitResi = () => {
  navigateTo({
    path: '/tracking',
    query: {
      order_id: cekResiForm.resi.join('|')
    }
  })
}

const cekAjaStore = useCekAjaStore()
const { setLoadOnMount } = cekAjaStore

const onSubmit = () => {
  setLoadOnMount(true)
  navigateTo({
    path: '/cekaja'
  })
}
</script>

<template>
  <CekajaForm
    class="lg:absolute lg:top-1/2 lg:left-1/2 transform lg:-translate-x-1/2 lg:-translate-y-7/12 xl:-translate-y-3/4"
    @submit="onSubmit"
  >
    <template #addon>
      <div
        class="p-5 lg:p-6 flex flex-col gap-4 justify-start flex-1 lg:max-w-5/12"
      >
        <div class="flex flex-col gap-1">
          <h2 class="font-bold font-display">
            Paketmu sedang dikirim? Cek posisinya di sini
          </h2>
          <p class="text-sm text-current/70">
            Masukkan nomor resi untuk lacak paketmu.
          </p>
        </div>
        <form
          class="grid lg:flex lg:items-stretch gap-3 lg:mt-auto"
          @submit.prevent="onSubmitResi"
        >
          <UiInputControl class="flex-1">
            <UiTagsInput
              id="input"
              ref="input"
              v-model="cekResiForm.resi"
              :max="3"
              class="bg-background"
              add-on-blur
              add-on-tab
              placeholder="Nomor Resi / Order ID (Max 3)"
              :style="{
                viewTransitionName: 'tracking-input'
              }"
            />
          </UiInputControl>
          <UiButton
            type="submit"
            class="shrink-0 rounded-xl"
            icon="material-symbols:arrow-forward"
            aria-label="Lacak Paket"
            :disabled="!cekResiForm.resi.length"
            :style="{
              viewTransitionName: 'tracking-button'
            }"
          />
        </form>
      </div>
    </template>
  </CekajaForm>
</template>
